export default __webpack_public_path__ + "static/media/event-icon.3a18d636.svg";